module.exports = __webpack_public_path__ + "static/media/0355_Small.8960d134.jpg";